import { getStringValue } from "services/util";
import { useTranslation } from "react-i18next";

export default function Text(props) {
  const { t } = useTranslation();
  return <span>{t("Common." + getStringValue(props.strings, props.strKey))}</span>;
}
